<template>
  <div>
    <!-- WIDTH 600+
    <v-btn
      class="button hidden-md-and-up button-back"
      fixed
      dark
      fab
      color="blue"
      @click="goBack"
    >
      <v-icon>undo</v-icon>
    </v-btn>
    -->
    <!-- WIDTH 600-
    <v-btn
      class="button hidden-sm-and-down"
      fixed
      dark
      fab
      bottom
      right
      color="blue"
      @click="goBack"
    >
      <v-icon>undo</v-icon>
    </v-btn>
    -->
    <v-btn
      class="button button-back"
      fixed
      dark
      fab
      bottom
      right
      color="blue"
      @click="goBack"
    >
      <v-icon>undo</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: [
    'goto'
  ],
  methods: {
    goBack () {
      this.$router.push(this.goto)
    }
  }
}
</script>

<style scoped>
.button {
  z-index: 100;
}

.button-back {
  bottom: 15px;
  right: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ButtonGoBack.vue